import querystring from "query-string";
import axiosInstance, { errorHandler } from "./api";
import { formatISO, startOfToday, startOfTomorrow } from "date-fns";
import { APP_CONST, getStoredItem } from "@/store/dataStore";

const TRANSACTIONS_URL =
  "/report-service/api/transfer-management/iroha-transactions";

const getTransactions = axios => direction => (
  page,
  size,
  filter = "",
  sort = "transactionCreatedTime,desc",
  type = "ALL",
) =>
  axios
    .get(
      `${TRANSACTIONS_URL}/${direction}?${querystring.stringify({
        page,
        size,
        filter,
        sort,
        type,
      })}`,
    )
    .then(({ data, headers }) => ({
      data: data.data,
      total: Number(headers["x-total-count"]),
      hasNext: headers["hasnext"] === "true",
      hasPrevious: headers["hasprevious"] === "true",
    }))
    .catch(errorHandler);

// TransferManagementResource.getIncomingIrohaTransactions
const getIncomingTransactions = axios => getTransactions(axios)("incoming");
// TransferManagementResource.getOutgoingIrohaTransactions
const getOutgoingTransactions = axios => getTransactions(axios)("outgoing");

// TransferManagementResource.getTodayIncomingIrohaTransactions
/*
 *  Dashboad for Manager -> Incoming transactions
 */
const getTodayIncomingTransactions = axios =>
  getTransactions(axios)("incoming/today");

// TransferManagementResource.getTodayOutgoingIrohaTransactions
/*
 *  Dashboad for Manager -> outgoing transactions
 */
const getTodayOutgoingTransactions = axios =>
  getTransactions(axios)("outgoing/today");

// TransferManagementResource.getIrohaTransactionDetailsById
const getTransaction = axios => id =>
  axios
    .get(`${TRANSACTIONS_URL}/${id}`)
    .then(({ data }) => data)
    .catch(errorHandler);

// TransferManagementResource.getIrohaTransactionsByAccountIdAndAssetId
const getUserTransaction = axios => (accountId, id) =>
  axios
    .get(`${TRANSACTIONS_URL}/${accountId}/${id}`)
    .then(({ data }) => data)
    .catch(errorHandler);

// TransferManagementResource.getIrohaTransactionsHistoryByAccountIdAndAssetId
const getUserHistoryTransaction = axios => (accountId, id) =>
  axios
    .get(`${TRANSACTIONS_URL}/history/${accountId}/${id}`)
    .then(({ data }) => data)
    .catch(errorHandler);

// TransferManagementResource.getMobileTransactionsByAccountId
const getAccountTransactions = axios => (
  id,
  page,
  size,
  filter = "",
  sort = "",
  type = "ALL",
  from = "",
  to = "",
) =>
  axios
    .get(
      `${TRANSACTIONS_URL}/account-details/${id}?${querystring.stringify({
        filter,
        page,
        size,
        sort,
        from,
        to,
        type,
      })}`,
    )
    .then(({ data, headers }) => ({
      data: data.data,
      total: Number(headers["x-total-count"]),
      hasNext: headers["hasnext"] === "true",
      hasPrevious: headers["hasprevious"] === "true",
    }))
    .catch(errorHandler);

const INCOMING_TX_URL = "/tps/api/transfer-management/incoming-transactions";

// TransferManagementResource.acknowledge
const acknowledge = axios => fstTrxId => {
  return axios
    .post(`${INCOMING_TX_URL}/acknowledge`, { fstTrxId })
    .then(({ data }) => data)
    .catch(errorHandler);
};

// TransferManagementResource.refund
const refund = axios => fstTrxId => {
  return axios
    .post(`${INCOMING_TX_URL}/refund`, { fstTrxId })
    .then(({ data }) => data)
    .catch(errorHandler);
};

// TransferManagementResource.search
const search = axios => ({
  page,
  size,
  sort,
  type = "ALL",
  accountId,
  search,
  currencies,
  directions,
  directionSubject,
  status,
  fromDatetime,
  toDatetime,
  fromDate,
  toDate,
  businessStatus,
}) => {
  return axios
    .post(
      `${TRANSACTIONS_URL}/${directionSubject}?${querystring.stringify({
        page,
        size,
        sort,
        type,
      })}`,
      {
        accountId,
        search,
        currencies,
        directions,
        status,
        fromDatetime,
        toDatetime,
        businessStatus,
        fromDate,
        toDate,
      },
    )
    .then(({ data, headers }) => ({
      data: data.data,
      total: Number(headers["x-total-count"]),
      hasNext: headers["hasnext"] === "true",
      hasPrevious: headers["hasprevious"] === "true",
    }));
};
const searchInstance = search(axiosInstance);
const searchAdapter = ({
  direction,
  directionSubject,
  isToday,
  fromDate,
  toDate,
}) => (
  page,
  size,
  search = "",
  sort = "",
  businessStatus = [],
  status = [],
) => {
  return searchInstance({
    page,
    size,
    sort,
    search,
    status: status ? (Array.isArray(status) ? status : [status]) : [],
    businessStatus: businessStatus
      ? Array.isArray(businessStatus)
        ? businessStatus
        : [businessStatus]
      : [],
    accountId: JSON.parse(getStoredItem(APP_CONST.USER_INFO)).accountId,
    currencies: [],
    directions: [direction],
    directionSubject: directionSubject,
    fromDatetime: isToday ? formatISO(startOfToday()) : fromDate,
    toDatetime: isToday ? formatISO(startOfTomorrow()) : toDate,
  });
};

export default {
  getIncomingTransactions: getIncomingTransactions(axiosInstance),
  getOutgoingTransactions: getOutgoingTransactions(axiosInstance),
  getTodayIncomingTransactions: getTodayIncomingTransactions(axiosInstance),
  getTodayOutgoingTransactions: getTodayOutgoingTransactions(axiosInstance),
  getTransaction: getTransaction(axiosInstance),
  getUserTransaction: getUserTransaction(axiosInstance),
  getUserHistoryTransaction: getUserHistoryTransaction(axiosInstance),
  getAccountTransactions: getAccountTransactions(axiosInstance),
  acknowledge: acknowledge(axiosInstance),
  refund: refund(axiosInstance),
  search: searchInstance,
  searchAdapter,
};
